import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import PropTypes from 'prop-types';

import colors from 'common/constants/colors';
import { ShowDefaultPartnerContact } from 'common/utils/featureFlags';

// Inline confirmation under a field whose value on file was cleared. Back is focused first so a
// stray Enter keeps the value. The backend fallback is kept in the same state as the
// default-contact switch, so with it off nothing is sent until a new value is added.
const describeWhereNotificationsGo = (noun) =>
  ShowDefaultPartnerContact
    ? `Its notifications will go to the patient's default ${noun} instead.`
    : `Its notifications for this patient will not be sent until a new ${noun} is added.`;

const RemovePartnerContactAlert = ({ partnerName, noun, onBack, onRemove }) => (
  <Alert
    severity='warning'
    icon={<WarningAmberIcon fontSize='inherit' sx={{ color: colors.warningAlertIcon }} />}
    sx={{
      mt: 1.5,
      bgcolor: colors.warningAlertSurface,
      color: colors.warningAlertText,
      alignItems: 'center',
      '& .MuiAlert-message': { flex: 1 },
    }}
    action={
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
        <Button size='small' color='inherit' onClick={onBack} autoFocus>
          Back
        </Button>
        <Button size='small' variant='contained' color='error' onClick={onRemove}>
          Remove
        </Button>
      </Box>
    }
  >
    <AlertTitle sx={{ mb: 0, fontSize: 14 }}>{`Remove ${partnerName}'s ${noun}?`}</AlertTitle>
    {`${partnerName} will no longer have its own ${noun} on file. ${describeWhereNotificationsGo(noun)}`}
  </Alert>
);

RemovePartnerContactAlert.propTypes = {
  partnerName: PropTypes.string.isRequired,
  noun: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default RemovePartnerContactAlert;
